import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ScrollablePanel = styled.div`
  height: 100%;
  overflow: auto;
`;

const FlexPanel = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const SectionPanel = ({ scrollable, children }) => {
  if (scrollable) {
    return <ScrollablePanel>{children}</ScrollablePanel>;
  }
  return <FlexPanel>{children}</FlexPanel>;
};

SectionPanel.propTypes = {
  scrollable: PropTypes.bool,
  children: PropTypes.node,
};

SectionPanel.defaultProps = {
  scrollable: false,
};

export default SectionPanel;
